import { Location } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WorkOrdersService } from '../work-orders/work-orders.service';
import { AuthenticationService } from '../../../auth.service';

const VALID_ROUTE_URL = '/VE/Work-Orders';
const VALID_ROUTE_URL_2 = '/VE/Work-Orders/Reports';
const VALID_ROUTE_URL_3 = '/VE/Work-Orders/Search';

@Injectable()
export class WorkOrderGuard implements CanActivate {
    router: Router;
    location: Location;
    workOrdersService: WorkOrdersService;

    constructor(injector: Injector, private readonly authService: AuthenticationService) {
        this.router = injector.get(Router);
        this.location = injector.get(Location);
        this.workOrdersService = injector.get(WorkOrdersService);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isValid = this.router.url === VALID_ROUTE_URL || this.router.url === VALID_ROUTE_URL_2 || this.router.url === VALID_ROUTE_URL_3; 
        if (!isValid) {  // User is accessing route directly, route user back to homepage   
            this.router.navigate(['']);
            return false;
        }

        if (this.workOrdersService.isNewWO) { return true; }

        let validRoute = false;

        const status = this.workOrdersService.workOrderStatus.value.find(x => {
            return x.Id === this.workOrdersService.editData.StatusId;
        });

        if (status) {
            validRoute = this.authService.isWorkOrderEditClaimValid(route, status.Description);
        }

        return validRoute;
    }
}
